angular
	.module('claimVic.controller')
	.constant('claimReviewWording', {
		REVIEW_CLAIM_SUCCESS: 'Thank you, your claim review form has been sent to EML.'
	});